module.exports = {
	"header": "404 - Page not found",
	"ln1": "Oops! The page your requested doesn't seem to exist!",
	"ln2": "Perhaps the link that brought you here has expired or is invalid."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/404.json5
// module id = 1915
// module chunks = 6